import { JSX, useState, SyntheticEvent, ReactNode } from 'react';
import {
    useRecordContext
} from 'react-admin'
import {
    Grid,
    Box,
    Tabs,
    Tab
} from '@mui/material';
import { EmailFinderConfigurationPanel } from "./EmailFinderConfigurationPanel";
import { EmailFinderActivityPanel } from "./EmailFinderActivityPanel";

interface TabPanelProps {
    children?: ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps): JSX.Element {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number): { id: string, 'aria-controls': string } {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const EmailFinderManagerContainer: () => JSX.Element = (): JSX.Element => {
    const [value, setValue] = useState(0);

    const handleChange: (event: SyntheticEvent, newValue: number) => void = (event: SyntheticEvent, newValue: number): void => {
        setValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } } >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Configuration" {...a11yProps(0)} />
                    <Tab label="Activity" {...a11yProps(1)} />
                    {/*<Tab label="Item Three" {...a11yProps(2)} />*/}
                </Tabs>
            </Box>
            <Box sx={ { width: '100%' } } >
                <CustomTabPanel value={value} index={0}>
                    <EmailFinderConfigurationPanel />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <EmailFinderActivityPanel />
                </CustomTabPanel>
                {/*<CustomTabPanel value={value} index={2}>*/}
                {/*    Item Three*/}
                {/*</CustomTabPanel>*/}
            </Box>
        </Box>
    );
}